<div class="dialog-wrapper">
  <h4 class="dialog-title">Transplant Center Selection</h4>

  <div class="table-responsive">
    <table class="table table-striped table-bordered table-hover">
      <tbody>
        @for (item of cibmtrCenters; track item) {
          <tr (click)="selectRow(item)">
            <td class="radio-cell">
              <input name="center" type="radio" [value]="item" [(ngModel)]="currentItem" />
            </td>
            <td>{{ item.value }}</td>
            <td>{{ item.name }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="dialog-actions">
    <button type="button" class="btn btn-primary buttonColor" (click)="onContinue()">
      Continue
    </button>
  </div>
</div>
